import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, TextField, Divider, CircularProgress } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import AddIcon from '@material-ui/icons/Add'
import { getLabelEndereco } from 'helpers/labels'
import { useLocal } from 'hooks/useLocal'
import { Form as FormAddLocal } from '../../views/Locais/EditarLocal/components/Form/Form'
import { CustomButton } from 'components/CustomButton'
import useStyles from './FormLocalColeta.styles'

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
})

export const FormLocalColeta = (props) => {
  const { value, onChange, idCaso, idVeiculo, setDisableNextButton, children } = props
  const classes = useStyles()
  const localService = useLocal()
  const [isAddLocalOn, setIsAddLocalOn] = useState(false)
  const [locaisCaso, setLocaisCaso] = useState([])
  const [processando, setProcessando] = useState(false)

  // Carregar locais do caso ou veículo com controle de montagem para evitar memory leaks
  useEffect(() => {
    let isMounted = true

    const fetchLocais = async () => {
      const safeSetLocais = (data) => {
        if (isMounted) setLocaisCaso(data || [])
      }
      const safeSetProcessando = (loading) => {
        if (isMounted) setProcessando(loading)
      }

      if (idVeiculo) {
        await localService.listarLocaisDeCasosPorVeiculo(idVeiculo, safeSetLocais, safeSetProcessando)
        return
      }
      await localService.listarLocaisDeCaso(idCaso, safeSetLocais, safeSetProcessando)
    }

    fetchLocais()

    return () => {
      isMounted = false
    }
  }, [idCaso, idVeiculo, isAddLocalOn])

  // Selecionar automaticamente o primeiro local se nenhum estiver selecionado
  useEffect(() => {
    if (!value && locaisCaso.length > 0 && onChange) {
      onChange(locaisCaso[0])
    }
  }, [locaisCaso, value, onChange])

  // Desabilitar botões externos se estiver na tela de adição de novo local
  useEffect(() => {
    if (setDisableNextButton) {
      setDisableNextButton(isAddLocalOn)
    }
  }, [isAddLocalOn, setDisableNextButton])

  const handleClickAddLocal = () => {
    setIsAddLocalOn(true)
  }

  return (
    <Grid container spacing={2}>
      {isAddLocalOn ? (
        <Grid item xs={12}>
          <FormAddLocal local={{}} idCaso={idCaso} setOpenFicha={setIsAddLocalOn} />
        </Grid>
      ) : (
        <Grid item xs={12}>
          {processando ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} container justifyContent="flex-end">
                <CustomButton
                  colorType="secondary"
                  variant="contained"
                  onClick={handleClickAddLocal}
                  startIcon={<AddIcon />}
                >
                  Cadastrar novo local
                </CustomButton>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '16px' }}>
                <Autocomplete
                  name="endOrig"
                  filterOptions={filterOptions}
                  noOptionsText="Sem informações"
                  options={locaisCaso}
                  value={value || null}
                  getOptionSelected={(option, val) => option.id === val.id}
                  onChange={(event, newValue) => {
                    if (onChange) {
                      onChange(newValue)
                    }
                  }}
                  getOptionLabel={(option) => getLabelEndereco(option)}
                  renderOption={(option) => getLabelEndereco(option)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Selecione um dos locais cadastrados no caso"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}
          {children && (
            <Grid item xs={12} style={{ marginTop: '16px' }}>
              <Divider style={{ marginBottom: '16px' }} />
              {children}
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  )
}

FormLocalColeta.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  idCaso: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idVeiculo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setDisableNextButton: PropTypes.func,
  children: PropTypes.node,
}
